const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const AssetsNavigator = require('components/commons/AssetsNavigator/AssetsNavigator');
const { FormattedText} = require('core/i18n').i18n;
const {
    selectUserFundNext,
    selectUserFundPrev,
    selectUserFunds,
    selectUserFund
} = require('../../selectors/fundsSelectors');

class MyFundsNavigator extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            fund,
            userFund,
            userFunds,
            userFundNext,
            userFundPrev
        } = this.props;
        return (<React.Fragment>{
                userFund && <AssetsNavigator
                    next={userFundNext && `/myprofile/broker/fund/isin/${userFundNext.isin}?contractId=${userFundNext.id}`}
                    prev={userFundPrev && `/myprofile/broker/fund/isin/${userFundPrev.isin}?contractId=${userFundPrev.id}`}
                    >
                    <FormattedText
                        value="fundsCard-assetNavigatorLabel"
                        injectedStrings={[
                            userFunds.findIndex(f => f.customInstitutionSecurityId === fund.customInstitutionSecurityId && f.id === userFund.id) + 1,
                            userFunds.length,
                        ]}
                    />
                </AssetsNavigator>
            }
        </React.Fragment>);
    }
}

MyFundsNavigator.propTypes = {
    fund: PropTypes.object,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    userFundNext: PropTypes.object,
    userFundPrev: PropTypes.object,
    userFund: PropTypes.object.isRequired,
    userFunds: PropTypes.array.isRequired,
};

const mapStateToProps = (state, props) => ({
    userFund: selectUserFund(state, props),
    userFunds: selectUserFunds(state, props),
    userFundNext: selectUserFundNext(state, props),
    userFundPrev: selectUserFundPrev(state, props)
});

module.exports = connect(mapStateToProps, ()=>({}))(MyFundsNavigator);
